module.exports = __webpack_public_path__ + "img/lintete.6160e51f.png";